import React from "react";
import AllWarehouses from "./WarehouseModule/Allwarehouses";

const Warehouse = () => {
  return (
    <div>
      <AllWarehouses />
    </div>
  );
};

export default Warehouse;
